import styled from 'styled-components'
import Marquee from '@components/Marquee'
import { down, up } from 'styled-breakpoints'

const StyledImagesMarquee = styled.div`
  .marquee > div {
    align-items: center;
  }

  .marque__item {
    margin-right: 3.2rem;
  }

  img {
    border-radius: 0.8rem;
    object-fit: cover;
  }
`

const StyledImage = styled.img<{ tall?: boolean }>`
  height: ${({ tall }) => tall && '72rem'};

  ${down('md')} {
    max-height: ${({ tall }) => (tall ? '40rem' : '30rem')};
  }
`

const StyledColumn = styled.div`
  flex-direction: column;

  ${up('md')} {
    height: 72rem;
  }

  ${down('md')} {
    flex-direction: row;
    align-items: center;

    img {
      margin-bottom: 0;

      &:not(:last-child) {
        margin-right: 3.2rem;
      }
    }
  }

  img {
    max-width: 32.8rem;

    ${up('md')} {
      height: 50%;
    }

    &:not(:last-child) {
      ${up('md')} {
        margin-bottom: 3.2rem;
      }
    }
  }
`

const ImagesMarquee = () => (
  <StyledImagesMarquee>
    <Marquee reverse duration={40}>
      <StyledImage
        className="marque__item"
        src="images/team/featured/team-01.jpg"
      />
      <StyledImage
        tall
        className="marque__item"
        src="images/team/featured/team-02.jpg"
      />
      <StyledImage
        className="marque__item"
        src="images/team/featured/team-04.jpg"
      />
      <StyledColumn className="marque__item" key="04">
        <StyledImage src="images/team/featured/team-03.jpg" />
        <StyledImage src="images/team/featured/team-05.jpg" />
      </StyledColumn>
    </Marquee>
  </StyledImagesMarquee>
)

export default ImagesMarquee
